<div class="container-fluid">
    <div class="row">
        <div class="col-md-6 title">Unit</div>
        <div class="col-md-6">{{Instruction.units}}</div>
    </div>
    <div class="row"></div>
    <div class="row mt-10">
        <div class="col-md-6 title">Issued From</div>
        <div class="col-md-6">{{DateFormatHelper.GetDisplayDateOnly(Instruction.issuedFrom)}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Issued To</div>
        <div class="col-md-6">{{DateFormatHelper.GetDisplayDateOnly(Instruction.issuedTo?? '')}}</div>
    </div>

    <div class="row mt-10">
        <div class="col-md-6 title">Date Comments</div>
        <div class="col-md-6">{{Instruction.dateComment}}</div>
    </div>
    <div class="row mt-10">
        <div class="col-md-6 title">Status</div>
        <div class="col-md-6">{{Instruction.status}}
            @if(Instruction.isArchived){
             - Archived
        }</div>
        
    </div>  

    
    @if(Instruction.status == 'New' && UserService.getUser()?.IsTrader){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ChangeStatus('Acknowledged')">
                Acknowledge
            </nj-button>
        </div>
    </div>}

    @if(Instruction.status == 'Acknowledged' && UserService.getUser()?.IsTrader){
    <div class="row mt-10">
        <div class="col-md-6"></div>
        <div class="col-md-6"><nj-button size="normal" type="button" [isDisabled]="false" icon=""
                [hasCustomIcon]="false" (buttonClick)="ChangeStatus('Completed')">
                Complete
            </nj-button>
        </div>
    </div>}
    <!-- Archive / UnArchive -->
    @if(UserService.getUser()?.CanArchive){
        <div class="row mt-10">
            <div class="col-md-6"></div>
            <div class="col-md-6">
                <nj-button size="normal" type="button" [isDisabled]="false" icon=""
                    [hasCustomIcon]="false" (buttonClick)="ChangeStatus(Instruction.isArchived ? 'UnArchive' : 'Archive')">
                    {{ Instruction.isArchived ? 'Unarchive' : 'Archive' }}
                </nj-button>
            </div>
        </div>}

    <div class="row title  mt-10 col-md-12">
        Subject
    </div>
    <div class=" row col-md-12">{{Instruction.subject}}</div>
    <div class="row title col-md-12 mt-10">
        Details
    </div>
    <div class=" row col-md-12">{{Instruction.details}}</div>

    <div class="row mt-10">
        <div class="col-md-12" [style]="'margin-top: 10px;'">
            <table border="1" [cellSpacing]="0" [cellPadding]="2" [width]="'100%'">
                <thead>
                    <tr>
                        <th>D-2 Forecast Index</th>
                        <th>Argus</th>
                        <th>LEBA (8-9)</th>
                        <th>LEBA (all Day)</th>
                        <th>N2EX</th>
                        <th>PX</th>
                    </tr>
                </thead>
                <tbody>
                    @for(d2Forecast of Instruction.forecasts; track d2Forecast; let ix = $index;){
                    <tr>
                        <td>
                            {{DateFormatHelper.GetDisplayDateOnly(d2Forecast.forecastDate)}}
                        </td>
                        <td>
                            {{d2Forecast.argus}}
                        </td>
                        <td>
                            {{d2Forecast.leba_8_9}}
                        </td>
                        <td>
                            {{d2Forecast.leba_all}}
                        </td>
                        <td>
                            {{d2Forecast.n2EX}}
                        </td>
                        <td>
                            {{d2Forecast.pX}}
                        </td>
                    </tr>
                    }
                </tbody>
            </table>
        </div>
    </div>

    <div class="row mt-10" [style]="'margin-top: 20px;'">
        Attachments
    </div>

    <div class="row mt-10">
        <table id="Attachments" class="nj-table nj-table--hover nj-table--striped nj-cursor">
            <thead>
                <tr [style]="'background-color: #d8d8d8'">
                    <th>File</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                @for (file of Instruction.files; track file; let ix = $index) {
                <tr>
                    <td>{{file.fileName}}</td>
                    <td>
                        <nj-button size="normal" type="button" icon="" [hasCustomIcon]="false"
                            (buttonClick)="DownloadFile(file.fileId, file.fileName)">
                            Download
                        </nj-button>
                    </td>
                </tr>
                }
            </tbody>
        </table>


    </div>
</div>